import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';
import {
  PROVIDER_LIST_WIDE_QUERY,
  PROVIDER_TILE_SIZE,
  PROVIDER_TILE_SIZE_WIDE,
} from '../ProviderList/providerListContainer';

const Row = styled('li')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${PROVIDER_TILE_SIZE}px minmax(0, 1fr)`,
  columnGap: theme.spacing(1.5),
  alignItems: 'center',
  minHeight: theme.spacing(9),
  paddingBlock: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
  [PROVIDER_LIST_WIDE_QUERY]: {
    gridTemplateColumns: `${PROVIDER_TILE_SIZE_WIDE}px minmax(0, 1fr)`,
    columnGap: theme.spacing(2),
    minHeight: theme.spacing(7),
    paddingBlock: theme.spacing(1),
  },
}));

const Tile = styled('span')({
  display: 'flex',
  [PROVIDER_LIST_WIDE_QUERY]: {
    width: PROVIDER_TILE_SIZE_WIDE,
    height: PROVIDER_TILE_SIZE_WIDE,
    overflow: 'hidden',
  },
});

const Lines = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

/** Placeholder mirroring a `ProviderListItem` while the directory loads. */
export function ProviderListItemSkeleton() {
  return (
    <Row aria-hidden="true">
      <Tile>
        <Skeleton variant="rounded" width={PROVIDER_TILE_SIZE} height={PROVIDER_TILE_SIZE} />
      </Tile>
      <Lines>
        <Skeleton variant="text" width="45%" />
        <Skeleton variant="text" width="70%" />
      </Lines>
    </Row>
  );
}
